import { all, takeEvery, call, put } from "redux-saga/effects";
import { list, create, detail, update, remove } from "services/apis/monitoring";
import { getScreen } from "services/apis/scadaProject";
import actions from "./actions";
import * as _ from "lodash";
import { toastr } from "services/toastr";
import { history } from "redux/store";

const generalMonitoringListFilter = {
  filters: JSON.stringify([["type", "=", "general"]]),
};

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* LIST({ payload }) {
  yield loading(true);

  const response = yield call(list, payload);
  if (response) {
    const meta = _.omit(response, "items");
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        list: response.items,
        meta,
      },
    });
  }
  if (!response) {
    yield loading(false, true);
  }
}

export function* LIST_GENERAL({ payload }) {
  yield loading(true);

  const response = yield call(list, payload);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        loading: false,
        generalList: response.items.filter((item) => String(item.type).toLowerCase() === "general"),
      },
    });
  }
  if (!response) {
    yield loading(false, true);
  }
}

export function* CREATE({ payload }) {
  const { body } = payload;
  yield loading(true);

  const response = yield call(create, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    history.push("/monitorings");
    yield put({
      type: actions.LIST,
      payload: { page: 1, pageSize: 20, ...generalMonitoringListFilter },
    });
    yield put({
      type: actions.LIST_GENERAL,
      payload: { page: 1, pageSize: 1000, ...generalMonitoringListFilter },
    });
    toastr.success("create succeeded", "created new monitoring!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DETAIL({ payload }) {
  const { id, projectId, filter } = payload;
  yield loading(true);

  const response = projectId
    ? yield call(getScreen, projectId, id, filter)
    : yield call(detail, id, filter);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* UPDATE({ payload }) {
  const { id, body } = payload;
  yield loading(true);

  const response = yield call(update, id, body);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    history.push("/monitorings");
    yield put({
      type: actions.LIST,
      payload: { page: 1, pageSize: 20, ...generalMonitoringListFilter },
    });
    yield put({
      type: actions.LIST_GENERAL,
      payload: { page: 1, pageSize: 1000, ...generalMonitoringListFilter },
    });
    toastr.success("update succeeded", "updated monitoring!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export function* DELETE({ payload }) {
  const { id, totalItems, filter } = payload;
  const { page, pageSize } = filter;
  let newPage = page;

  if (totalItems % pageSize <= 1 && page !== 1) {
    newPage -= 1;
  }

  yield loading(true);

  const response = yield call(remove, id);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        detail: response,
        loading: false,
      },
    });

    yield put({ type: actions.LIST, payload: { ...filter, page: newPage } });
    yield put({
      type: actions.LIST_GENERAL,
      payload: { page: 1, pageSize: 1000, ...generalMonitoringListFilter },
    });
    toastr.success("delete succeeded", "successfully deleted monitoring!");
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LIST, LIST),
    takeEvery(actions.LIST_GENERAL, LIST_GENERAL),
    takeEvery(actions.CREATE, CREATE),
    takeEvery(actions.DETAIL, DETAIL),
    takeEvery(actions.UPDATE, UPDATE),
    takeEvery(actions.DELETE, DELETE),
  ]);
}
